module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.3ac50b5b.ttf";